import { FC } from 'react';
import { Box } from '@mui/material';

interface IBureauAddress {
  bureauTypeName: keyof typeof BUREAU_ADDRESS_TEXT;
}

export const BUREAU_ADDRESS_TEXT: Record<string, string[]> = {
  Transunion: [
    'TRANSUNION TEST FACILITY Credit Prequal',
    'TRANSUNION TEST FACILITY',
    '555, W ADAMS',
    'CHICAGO, IL 60661',
    '800-888-4213',
  ],
  Equifax: [
    'Equifax Credit Prequal',
    'Equifax',
    'PO BOX, 740241',
    'Atlanta, GA 30374-0241',
    '1-800-685-1111',
  ],
  Experian: [
    'Experian Credit Prequal',
    'Experian',
    '701 Experian Parkway P.O. Box 2002',
    'Allen, TX 75013-0036',
    '1-888-397-3742',
  ],
  ExperianFico: [
    'Experian Credit Prequal',
    'Experian',
    '701 Experian Parkway P.O. Box 2002',
    'Allen, TX 75013-0036',
    '1-888-397-3742',
  ],
};

export const BureauAddress: FC<IBureauAddress> = ({ bureauTypeName }) => {
  const address = BUREAU_ADDRESS_TEXT[bureauTypeName];

  if (!address) {
    return null;
  }

  return (
    <>
      {address.map((line, index) => (
        <Box key={index} fontWeight={index === 0 ? 'bold' : 'normal'}>
          {line}
        </Box>
      ))}
    </>
  );
};